import React from 'react';
import SubNavigation from '../navigation/SubNavigation';
import { urlParser } from '../helpers/url';
import { useParams } from 'react-router-dom';
import { Back } from '../back/Back';

/**
 * @param {{
 *   page: import('../Kalkhoff').Page,
 *   children?: JSX.Element | JSX.Element[],
 * }} arg React props
 * @returns {JSX.Element} ...
 */
export default function OfflineView({ page, children }) {
  /**
   * @type {object}
   * @property {string} slug Unique identifier
   * @property {string} topic Unique identifier
   */
  const { topic } = useParams();

  return <article className="default-view">
    { topic &&
      <Back
        pageClass='default-view'
      />
    }
    <h1 dangerouslySetInnerHTML={ {
      __html: page.title?.rendered,
    } }
    className="default-view__title"/>
    <SubNavigation
      topic={ 'offline' }
    />
    { children || <article dangerouslySetInnerHTML={ {
      __html: urlParser(page.content?.rendered),
    } }
    className="default-view__content"/> }
  </article>;
}
